@if (!notFurnitureOnly || !containsFurnitureRules) {
<div class="p-a-2 m-b-1 p2"
     [ngStyle]="{'background-color': backgroundColor || '#ECF4C1', 'color': textColor || '#333333' }">
    @if (notFurnitureOnly && !containsFurnitureRules) {
    @if (userHaveMaxDiscount) {
    {{'You have FREE' | translate}}&thinsp;
    @for (rule of rules; track $index) {
    @if (rule.isFullfilled) {
    <span class="s2">{{rule.name | translate}}</span>
    @if (!$last) {
    {{'and' | translate}}
    }
    } @else {
    {{toPriceString(rule.neededValue) | translate}}&nbsp;<span class="s2">{{rule.name |
        translate}}</span>
    }
    }
    } @else {
    @for (rule of rules; track $index) {
    @if (currentActiveRule.name === rule.name) {
    <span class="p-r-3 p-l-3-s block-s center-s">
        {{toPriceString(rule.neededValue) | translate}} {{'away from FREE' | translate}}&thinsp;
        <span class="s2">{{rule.name | translate}}</span>
    </span>
    }
    }
    @if (!isBasketView) {
    <button class="inline-block center underline no-wrap"
            (click)="close()">{{'Continue shopping' | translate}}</button>
    }
    @if (isBasketView) {
    <a class="block-s underline no-wrap"
       [routerLink]="'/'">{{'Continue shopping' | translate}}</a>
    }
    }
    }
    <!-- klarna available -->
    @if (containsFurnitureRules && !notFurnitureOnly) {
    <div>
        <span class="p1">{{'Spread the cost with' | translate}}</span>&nbsp;
        <span class="s1 p-r-3">{{'Klarna' | translate}}</span>
        <button type="button"
                class="underline"
                [clickEvent]="'basketklarnatray.toggle.request'">{{'Find out more' | translate}}</button>
    </div>
    }
</div>
}
